import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Checkbox from '@material-ui/core/Checkbox';

const BaseCheckBoxRenderer = ({ value, data, onCheck, disabled }) => {
  const [checked, setChecked] = useState(value);

  const onClickCheck = () => {
    if (!checked) {
      setChecked(true);
      onCheck(data);
    }
  };

  return (
    <Checkbox
      disabled={disabled}
      checked={checked}
      onChange={onClickCheck}
      color="primary"
    />
  );
};

BaseCheckBoxRenderer.propTypes = {
  data: PropTypes.any,
  value: PropTypes.any,
  onCheck: PropTypes.func,
  disabled: PropTypes.any,
};
export default BaseCheckBoxRenderer;
